import React, { Component } from 'react';
import { Container, Table, Button, Form, Modal, Col,Navbar } from 'react-bootstrap';
import axios from 'axios';
import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';
import { NavBar, Loading,AdminNav } from '../../helpers';


class EditRice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Rice: {},
      target: '',
      targetObj: '',
      modalShow: false,
      savingText : false
    }
  }

  componentWillMount() {
    console.log(this.props.location.state)
    this.setState({
      ...this.state,
      riceData : this.props.location.state
    })
    // setInterval(()=>{
    //   this.setState({
    //     ...this.state,
    //     savingText : !this.state.savingText
    //   })
    // },15000)
  }
  handleEditRiceTypeNameAndID(data){
    console.log(data)
    let c = axios.post(
      'https://backend1.riceinspections.com/testGA',
      { data: data }
    )
      .then((res) => {
        alert('บันทึกเรียบร้อยแล้ว')
      }).catch((err) => {
        alert('เกิดข้อผิดพลาด')
      })
  }
  handleChangeRiceNameToRiceType(e,objName,fieldName){
    this.setState({
      ...this.state,
      riceData : {
        ...this.state.riceData,
        [objName] : {
          ...this.state.riceData[objName],
          [fieldName] : e
        }
      }
    })
  }
  renderRiceType(riceData) {
    if(riceData) {
      return (
        Object.keys(riceData).map((a,idx) => {
            return <tr>
              <td>
                <Form.Group as={Col}>
                  <TextInput Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    value={riceData[a]['surveyNameTH']}
                    onChange={(e) => {this.handleChangeRiceNameToRiceType(e,a,'surveyNameTH')}}
                    className='form-control' trigger={''} />
                </Form.Group>
              </td> 
              <td>   
               <Form.Group as={Col}>
                  <TextInput Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    value={riceData[a]['surveyNameEN']}
                    onChange={(e) => {this.handleChangeRiceNameToRiceType(e,a,'surveyNameEN') }}
                    className='form-control' trigger={''} />
                </Form.Group>
                </td>
                <td>   
               <Form.Group as={Col}>
                  <TextInput Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    value={riceData[a]['surveyNameENFull']}
                    onChange={(e) => {this.handleChangeRiceNameToRiceType(e,a,'surveyNameENFull') }}
                    className='form-control' trigger={''} />
                </Form.Group>
                </td>
            </tr>
        })
      )
    }
  }
  showSaving(){
    if(this.state.savingText){
      return 'Saving...'
    }else{
      return 'Saved 1 min ago.'
    }
  }

  render() {
    return (
      <Container>
        <AdminNav></AdminNav>
        <NavBar /> 
        <Navbar style={{backgroundColor:'#F5F5F5'}} sticky="top" >
          <Container>
            <Navbar.Brand href="#">{
            // this.showSaving()
            } </Navbar.Brand>
            <Button onClick={()=>{this.handleEditRiceTypeNameAndID(this.state.riceData)}}> save </Button>
          </Container>
        </Navbar>

          <Table bordered hover>
          <thead>
            {<tr><th>ชื่อสถานที่ภาษาไทย</th><th>ชื่อสถานที่ภาษาอังกฤษ</th><th>ชื่อสถานที่ภาษาอังกฤษ (หนังสือรับรอง)</th></tr>}
          </thead>
          <tbody>
            {this.renderRiceType(this.state.riceData)}
          </tbody>
        </Table>
      </Container>
    );
  }
}

export default EditRice;
